/**
 * AUTO-GENERATED — do not edit by hand. Last generated: 2026-08-22T17:46:44.014Z.
 *
 * USD base prices from Stripe (the prices the STRIPE_LOOKUP_* keys resolve
 * to). Regenerated from Stripe on every build (`generate:pricing` runs first
 * in `build:vercel`) and baked into the bundle, so the pricing page renders
 * the real numbers statically — SEO + first paint — with no runtime Stripe
 * call.
 *
 * This committed copy is the fallback for PRICING_ALLOW_STALE=1 builds (dev /
 * preview without Stripe creds) and the value dev / tests / typecheck read
 * directly. A normal build FAILS rather than shipping it stale. See ADR-0089.
 */

interface GeneratedPlanPrice {
  /** USD base monthly amount (major units). */
  monthly: number;
  /** USD base annual amount (major units). */
  annual: number;
}

/** Keyed by paid plan id; Free / Business carry no Stripe price. */
export const GENERATED_PRICES: Record<'pro' | 'pro-family', GeneratedPlanPrice> = {
  'pro': { monthly: 7.99, annual: 76.99 },
  'pro-family': { monthly: 17.99, annual: 172.99 },
};
